var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConfirmIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 130,
  height: 129,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M.5 64.5C.5 28.898 29.398 0 65 0c11.37 0 22.026 2.958 31.285 8.147l-2.208 2.207A60.84 60.84 0 0 0 65 3C31.022 3 3.5 30.522 3.5 64.5S31.022 126 65 126s61.5-27.522 61.5-61.5c0-3.657-.369-7.235-.989-10.662l2.577-2.578A63.3 63.3 0 0 1 129.5 64.5c0 35.602-28.898 64.5-64.5 64.5S.5 100.102.5 64.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "m54.902 84.738 70.014-70.014 2.065 2.052-72.08 72.144L33 67.02l2.092-2.092z"
})));
export { SvgConfirmIcon as ReactComponent };
export default __webpack_public_path__ + "68718cfc160e3929b037d9269a586f21.svg";